/**
 * W-8BEN-E Models
 * Clean separation between API response model and form model with mapping logic
 */
import { determineStateFieldType, parseAddressComponents } from "../utils/formUtils";
// W8BEN-E Response Model - Fields that come from API endpoint
export class W8BENEResponseModel {
  // Basic identification fields
  "UniqueIdentifier": string = "";
  "Name of organization": string = "";
  "Country of incorporation or organization": string = "";
  "Date of birth": string = "";
  "W8-BENE-Name_of_disregarded_entity": string = "";

  // Address fields
  "Permanent residence address": string = "";
  "Permanent address country": string = "";
  "Permanent city address": string = "";
  "Mailing address": string = "";
  "Mailing address country": string = "";
  "Mailing address city": string = "";
  // Tax identification fields
  "U.S. taxpayer identification number": string = "";
  "GIIN": string = "";
  "W8-BENE-Foreign_tax_identifying_number": string = "";
  "W8-BENE-10_reference_number": string = "";

  // Form metadata
  "Form_name": string = "W-8BEN-E";
  "Form_revision_date": string = "";
  "Signature_date": string = "";
  "Signer_printed_name": string = "";
  "Signing_capacity": boolean = false;
  "Signature_unreadable": boolean = false;

  // Part I Chapter 3 Status (Entity Type) - Section 4
  "W8-BENE-4_central_bank": boolean = false;
  "W8-BENE-4_complex_trust": boolean = false;
  "W8-BENE-4_corporation": boolean = false;
  "W8-BENE-4_disregarded_entity": boolean = false;
  "W8-BENE-4_estate": boolean = false;
  "W8-BENE-4_foreign_government_controlled_entity": boolean = false;
  "W8-BENE-4_foreign_government_integral_part": boolean = false;
  "W8-BENE-4_grantor_trust": boolean = false;
  "W8-BENE-4_hybrid_treaty_claim_no": boolean = false;
  "W8-BENE-4_hybrid_treaty_claim_yes": boolean = false;
  "W8-BENE-4_international_organization": boolean = false;
  "W8-BENE-4_partnership": boolean = false;
  "W8-BENE-4_private_foundation": boolean = false;
  "W8-BENE-4_simple_trust": boolean = false;
  "W8-BENE-4_tax_exempt_organization": boolean = false;

  // Part I Chapter 4 Status (FATCA Status) - Section 5
  "W8-BENE-5_account_not_financial": boolean = false;
  "W8-BENE-5_active_nffe": boolean = false;
  "W8-BENE-5_certified_limited_life": boolean = false;
  "W8-BENE-5_certified_local_bank": boolean = false;
  "W8-BENE-5_certified_low_value": boolean = false;
  "W8-BENE-5_certified_sponsored": boolean = false;
  "W8-BENE-5_direct_reporting": boolean = false;
  "W8-BENE-5_entity_exempt_owners": boolean = false;
  "W8-BENE-5_excepted_affiliate": boolean = false;
  "W8-BENE-5_excepted_group": boolean = false;
  "W8-BENE-5_excepted_liquidation": boolean = false;
  "W8-BENE-5_excepted_startup": boolean = false;
  "W8-BENE-5_excepted_territory": boolean = false;
  "W8-BENE-5_exempt_retirement": boolean = false;
  "W8-BENE-5_fatca_501c_org_": boolean = false;
  "W8-BENE-5_foreign_government": boolean = false;
  "W8-BENE-5_international_organization": boolean = false;
  "W8-BENE-5_investment_entities": boolean = false;
  "W8-BENE-5_nonparticipating_ffi": boolean = false;
  "W8-BENE-5_nonprofit_org": boolean = false;
  "W8-BENE-5_nonreporting_iga": boolean = false;
  "W8-BENE-5_owner_documented": boolean = false;
  "W8-BENE-5_participating_ffi": boolean = false;
  "W8-BENE-5_passive_nffe": boolean = false;
  "W8-BENE-5_publicly_traded": boolean = false;
  "W8-BENE-5_registered_deemed": boolean = false;
  "W8-BENE-5_reporting_model1": boolean = false;
  "W8-BENE-5_reporting_model2": boolean = false;
  "W8-BENE-5_restricted_distributor": boolean = false;
  "W8-BENE-5_sponsored_direct": boolean = false;
  "W8-BENE-5_sponsored_ffi": boolean = false;
  "W8-BENE-5_territory_financial": boolean = false;

  // Part II Disregarded Entity or Branch
  "W8-BENE-11_branch_treated_as_nonparticipating_FFI": boolean = false;
  "W8-BENE-11_participating_FFI": boolean = false;
  "W8-BENE-11_reporting_Model1_FFI": boolean = false;
  "W8-BENE-11_reporting_Model2_FFI": boolean = false;
  "W8-BENE-11_us_branch": boolean = false;
  "W8-BENE-12_disregarded_entity_address": string = "";
  "W8-BENE-12_disregarded_entity_city_state_postal": string = "";
  "W8-BENE-12_disregarded_entity_country": string = "";
  "W8-BENE-13_giin": string = "";

  // Part III Claim of Tax Treaty Benefits
  "W8-BENE-14A_beneficial_owner_resident": boolean = false;
  "W8-BENE-14B_beneficial_owner_derives_item": boolean = false;
  "W8-BENE-14C_claiming_treaty_benefits": boolean = false;
  "W8-BENE-14A_country_name": string = "";

  "W8-BENE-14B_company_meets_active_trade_or_business": boolean = false;
  "W8-BENE-14B_company_meets_derivative": boolean = false;
  "W8-BENE-14B_company_meets_ownership_and_base_erosion_test": boolean = false;
  "W8-BENE-14B_favorable_discretionary_determination": boolean = false;
  "W8-BENE-14B_government": boolean = false;
  "W8-BENE-14B_no_lob": boolean = false;
  "W8-BENE-14B_other": boolean = false;
  "W8-BENE-14B_other_tax_exempt_organization": boolean = false;
  "W8-BENE-14B_publicly_traded_corporation": boolean = false;
  "W8-BENE-14B_subsidiary_of_publicly_traded": boolean = false;
  "W8-BENE-14B_tax_exempt_pension_trust": boolean = false;
  "W8-BENE-14B_other_text": string = "";

  "W8-BENE-15_additional_conditions_explaination": string = "";
  "W8-BENE-15_income_type": string = "";
  "W8-BENE-15_treaty_provision_and_paragraph": string = "";
  "W8-BENE-15_withholding_rate_percentage": string = "";

  // Part IV Sponsored FFI
  "W8-BENE-16_name_of_sponsoring_entity": string = "";
  "W8-BENE-17_controlled_foreign_corporation": boolean = false;
  "W8-BENE-17_investment_entity": boolean = false;

  // Part V Certified Deemed-Compliant Nonregistering Local Bank
  "W8-BENE-18_licensed_solely": boolean = false;

  // Part VI Certified Deemed-Compliant FFI with Only Low-Value Accounts
  "W8-BENE-19_investing_reinvesting_or_trading": boolean = false;

  // Part VII Certified Deemed-Compliant Sponsored, Closely Held Investment Vehicle
  "W8-BENE-20_sponsoring_entity_name": string = "";
  "W8-BENE-21_qi_wp_wt": boolean = false;

  // Part VIII Certified Deemed-Compliant FFI Limited Life Debt Investment Entity
  "W8-BENE-22_january_17_2013": boolean = false;

  // Part IX Certain Investment Entities that Do Not Maintain Financial Accounts
  "W8-BENE-23_section_1_1471": boolean = false;

  // Part X Owner-Documented FFI
  "W8-BENE-24A_owner_documented_FFI": boolean = false;
  "W8-BENE-24B_FFI_owner_reporting": boolean = false;
  "W8-BENE-24C_auditor_letter": boolean = false;
  "W8-BENE-24D_contingent_beneficiaries": boolean = false;

  // Part XI Restricted Distributor
  "W8-BENE-25A_restricted_distributors": boolean = false;
  "W8-BENE-25B_restricted_distributor_bound_agreement": boolean = false;
  "W8-BENE-25C_restricted_distributor_current_agreement": boolean = false;

  // Part XII Nonreporting IGA FFI
  "W8-BENE-26_model1_iga": boolean = false;
  "W8-BENE-26_model2_iga": boolean = false;
  "W8-BENE-26_nonreporting_iga_country": boolean = false;
  "W8-BENE-26_treated_as": string = "";
  "W8-BENE-26_country_name": string = "";
  "W8-BENE-26_trustee_foreign": boolean = false;
  "W8-BENE-26_trustee_sponsor_name": string = "";
  "W8-BENE-26_trustee_us": boolean = false;

  // Part XIII Foreign Government, Government of a U.S. Possession, or Foreign Central Bank of Issue
  "W8-BENE-27_foreign_government_checkbox": boolean = false;

  // Part XIV International Organisation
  "W8-BENE-28A_international_org_7701_checkbox": boolean = false;
  "W8-BENE-28B_international_org_intergovernmental": boolean = false;

  // Part XV Exempt Retirement Plans
  "W8-BENE-29A_retirement_plan_treaty": boolean = false;
  "W8-BENE-29B_retirement_plan_organized": boolean = false;
  "W8-BENE-29C_retirement_plan_fewer_50": boolean = false;
  "W8-BENE-29D_retirement_plan_401a": boolean = false;
  "W8-BENE-29E_retirement_plan_earn_income": boolean = false;
  "W8-BENE-29F_retirement_plan_government_sponsored": boolean = false;

  // Part XVI Entity Wholly Owned by Exempt Beneficial Owners
  "W8-BENE-30_entity_wholly_owned": boolean = false;

  // Part XVII Territory Financial Institution
  "W8-BENE-31_territory_financial_institution": boolean = false;

  // Part XVIII Excepted Nonfinancial Group Entity
  "W8-BENE-32_excepted_nonfinancial_group": boolean = false;

  // Part XIX Excepted Nonfinancial Start-Up Company
  "W8-BENE-33_excepted_startup": boolean = false;
  "W8-BENE-33_excepted_startup_formation_date": string = "";

  // Part XX Excepted Nonfinancial Entity in Liquidation or Bankruptcy
  "W8-BENE-34_excepted_liquidation": boolean = false;
  "W8-BENE-34_excepted_liquidation_filing_date": string = "";

  // Part XXI 501(c) Organization
  "W8-BENE_35_section_501c": boolean = false;
  "W8-BENE-35_section_501c_determination_date": string = "";

  // Part XXII Non-profit Organization
  "W8-BENE-36_nonprofit_organization": boolean = false;

  "W8-BENE-37A_publicly_traded_nffe": boolean = false;
  "W8-BENE-37A_securities_exchange_name": string = "";
  "W8-BENE-37B_entity_name": string = "";
  "W8-BENE-37B_name_of_securities": string = "";

  "W8-BENE-37B_nffe_affiliate": boolean = false;

  // Part XXIV Excepted Territory NFFE
  "W8-BENE-38_excepted_territory_nffe": boolean = false;

  // Part XXV Active NFFE
  "W8-BENE-39_active_nffe": boolean = false;

  // Part XXVI Passive NFFE
  "W8-BENE-40A_traded_nffe": boolean = false;
  "W8-BENE-40B_passive_nffe_no_substantial_owners": boolean = false;
  "W8-BENE-40C_passive_nffe_substantial_owners_provided": boolean = false;

  // Part XXVII Excepted Inter-Affiliate FFI
  "W8-BENE-41_affiliated_group": boolean = false;

  // Part XXVIII Sponsored Direct Reporting NFFE
  "W8-BENE-42_sponsoring_entity": string = "";
  "W8-BENE-43_nffe": boolean = false;

  // Certification fields
  // 'certify': boolean = false;
  "isSigned": string = "";
  "isModified": string = "no";

  // Dynamic fields support
  [key: string]: any;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class W8BENEFormModel {
  // Dynamic fields support
  [key: string]: any;

  // Basic identification fields (4 fields)
  "UniqueIdentifier": string = "";
  "Name of organization": string = "";
  "W8-BENE-Name_of_disregarded_entity": string = "";
  "Country of incorporation or organization": string = "";
  "Other": string = "";

  // Permanent Address fields (12 fields)
  "Permanent residence address": string = "";
  "Permanent address line 2": string = "";
  "Permanent address line 3": string = "";
  "Permanent address city": string = "";
  "Permanent address state USCA": string = "";
  "Permanent address state NonUS": string = "";
  "Permanent address zip": string = "";
  "Permanent address country": string = "";
  "Permanent address other": string = "";
  "Permanent address is care of": string = "no";
  "Permanent address is po box": string = "no";
  "Permanent address is rural route": string = "no";

  // Mailing Address fields (12 fields)
  "Mailing address": string = "";
  "Mailing address line 2": string = "";
  "Mailing address line 3": string = "";
  "Mailing city address": string = "";
  "Mailing address state USCA": string = "";
  "Mailing address state NonUS": string = "";
  "Mailing address zip": string = "";
  "Mailing address country": string = "";
  "Mailing address other": string = "";
  "Mailing address is care of": string = "no";
  "Mailing address is po box": string = "no";
  "Mailing address is rural route": string = "no";

  // Taxpayer identification fields (8 fields)
  "Taxpayer type": string = "";
  "U.S. taxpayer identification number": string = "";
  "GIIN": string = "";
  "GIINCheckBox": boolean = false;
  "GIIN Applied For": boolean = false;
  "Foreign TIN": boolean = false;
  "W8-BENE-Foreign_tax_identifying_number": string = "";
  "W8-BENE-FTIN_not_legally_required": boolean = false;
  "W8-BENE-10_reference_number": string = "";

  // Chapter 3 Status - Hybrid Treaty Claim dropdown
  "W8-BENE-4_hybrid_treaty_claim": string = "no";

  // Part II Disregarded Entity or Branch (8 fields)
  "W8-BENE-11_branch_treated_as_nonparticipating_FFI": boolean = false;
  "W8-BENE-11_participating_FFI": boolean = false;
  "W8-BENE-11_reporting_Model1_FFI": boolean = false;
  "W8-BENE-11_reporting_Model2_FFI": boolean = false;
  "W8-BENE-11_us_branch": boolean = false;
  "W8-BENE-12_disregarded_entity_address": string = "";
  "Address of disregarded entity line 2": string = "";
  "W8-BENE-12_disregarded_entity_city_state_postal": string = "";
  "W8-BENE-12_disregarded_entity_country": string = "";
  "W8-BENE-13_giin": string = "";

  // Part III Claim of Tax Treaty Benefits (20+ fields)
  "14a": boolean = false;
  "W8-BENE-14A_country_name": string = "";
  "14b": boolean = false;
  "W8-BENE-14A_beneficial_owner_resident": boolean = false;
  "W8-BENE-14B_beneficial_owner_derives_item": boolean = false;
  "W8-BENE-14C_claiming_treaty_benefits": boolean = false;
  "W8-BENE-14B_government": boolean = false;
  "W8-BENE-14B_tax_exempt_pension_trust": boolean = false;
  "W8-BENE-14B_other_tax_exempt_organization": boolean = false;
  "W8-BENE-14B_publicly_traded_corporation": boolean = false;
  "W8-BENE-14B_subsidiary_of_publicly_traded": boolean = false;
  "W8-BENE-14B_company_meets_ownership_and_base_erosion_test": boolean = false;
  "W8-BENE-14B_company_meets_derivative": boolean = false;
  "W8-BENE-14B_company_meets_active_trade_or_business": boolean = false;
  "W8-BENE-14B_favorable_discretionary_determination": boolean = false;
  "W8-BENE-14B_no_lob": boolean = false;
  "W8-BENE-14B_other": boolean = false;
  "W8-BENE-14B_other_text": string = "";
  "W8-BENE-15_additional_conditions_explaination": string = "";
  "14c": boolean = false;

  // Part IV Sponsored FFI (3 fields)
  "W8-BENE-16_name_of_sponsoring_entity": string = "";
  "W8-BENE-17_controlled_foreign_corporation": boolean = false;
  "W8-BENE-17_investment_entity": boolean = false;

  // Part V Certified Deemed-Compliant Nonregistering Local Bank (1 field)
  "W8-BENE-18_licensed_solely": boolean = false;

  // Part VI Certified Deemed-Compliant FFI with Only Low-Value Accounts (1 field)
  "W8-BENE-19_investing_reinvesting_or_trading": boolean = false;

  // Part VII Certified Deemed-Compliant Sponsored, Closely Held Investment Vehicle (2 fields)
  "W8-BENE-20_sponsoring_entity_name": string = "";
  "W8-BENE-21_qi_wp_wt": boolean = false;

  // Part VIII Certified Deemed-Compliant FFI Limited Life Debt Investment Entity (1 field)
  "W8-BENE-22_january_17_2013": boolean = false;

  // Part IX Certain Investment Entities that Do Not Maintain Financial Accounts (1 field)
  "W8-BENE-23_section_1_1471": boolean = false;

  // Part X Owner-Documented FFI (10+ fields)
  "W8-BENE-24A_owner_documented_FFI": boolean = false;
  "W8-BENE-24B_FFI_owner_reporting": boolean = false;
  "W8-BENE-24C_auditor_letter": boolean = false;
  "W8-BENE-24D_contingent_beneficiaries": boolean = false;
  "W8-BENE-25A_restricted_distributors": boolean = false;
  "W8-BENE-25B_restricted_distributor_bound_agreement": boolean = false;
  "W8-BENE-25C_restricted_distributor_current_agreement": boolean = false;
  "W8-BENE-26_nonreporting_iga_country": boolean = false;
  "W8-BENE-26_country_name": string = "";
  "W8-BENE-26_country_other": string = "";
  "W8-BENE-26_model1_iga": boolean = false;
  "W8-BENE-26_model2_iga": boolean = false;
  "W8-BENE-26_treated_as": string = "";
  "W8-BENE-26_trustee_us": boolean = false;
  "W8-BENE-26_trustee_foreign": boolean = false;

  // Signature and certification fields (8 fields)
  "Signature": string = "";
  "Signature_date": string = "";
  "Print_name": string = "";
  "Signing_capacity": boolean = false;
  "Signature_unreadable": boolean = false;
  // 'certify': boolean = false;
  "isSigned": string = "no";
  "isModified": string = "no";
  "Form_name": string = "W-8BEN-E";
  "Form_revision": string = "";

  // Mapping control field - prevents re-mapping when already done
  isMapDone: boolean = false;

  // Validation message fields for displaying TIN/GIIN validation on form load
  tinValidationMessage?: string | null = null;
  giinValidationMessage?: string | null = null;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      // If data was already mapped, preserve that state
      if (data.isMapDone) {
        console.log("W8BEN-E Form: Loaded previously mapped data, preserving isMapDone=true");
      }
    }
  }

  /**
   * Validate the form data
   */
  validate(): ValidationResult {
    const errors: Record<string, string> = {};

    return {
      isValid: Object.keys(errors).length === 0,
      fieldErrors: errors,
    };
  }
}

// Validation result interface
export interface ValidationResult {
  isValid: boolean;
  fieldErrors: Record<string, string>;
}

// Field Mapper - Converts between API response and form model
export class W8BENEFieldMapper {
  /**
   * Map API response to form model
   * Simple process: if isMapDone = false, map all values from response model to form model
   * If isMapDone = true, don't map values from API response
   */
  static mapResponseToForm(responseModel: W8BENEResponseModel): W8BENEFormModel {
    const formModel = new W8BENEFormModel();

    // Check if mapping is already done on the RESPONSE model to prevent re-mapping
    if ((responseModel as any).isMapDone) {
      console.log(
        "🛡️ W8BEN-E mapping already done (response isMapDone=true), skipping API response field mapping"
      );
      // Still return the response data but don't set isMapDone
      Object.keys(responseModel).forEach((key) => {
        if (responseModel[key] !== undefined) {
          (formModel as any)[key] = responseModel[key];
        }
      });

      // CRITICAL FIX: Always apply boolean conversion even for already-mapped data
      // This ensures checkboxes work correctly after save/reload
      this.convertBooleanFields(formModel);

      return formModel;
    }

    // Map all response model values to form model (direct mapping first)
    Object.keys(responseModel).forEach((key) => {
      if (responseModel[key] !== undefined) {
        (formModel as any)[key] = responseModel[key];
      }
    });

    // Apply special field mappings for API field name mismatches
    this.mapSpecialFields(responseModel, formModel);

    // Apply boolean conversion AFTER all mappings
    this.convertBooleanFields(formModel);

    // Set mapping done flag to prevent re-mapping
    formModel.isMapDone = true;
    console.log("✅ W8BEN-E field mapping completed, setting isMapDone=true");

    return formModel;
  }

  /**
   * Convert boolean fields that may come as strings from API to actual booleans
   */
  private static convertBooleanFields(formModel: W8BENEFormModel): void {
    // Always convert boolean fields to ensure checkboxes work correctly after save/reload
    console.log("🔄 W8BEN-E converting boolean fields to ensure proper checkbox states...");

    const booleanFields = [
      "GIINCheckBox",
      "GIIN Applied For",
      "Foreign TIN",
      "W8-BENE-FTIN_not_legally_required",
      "14a",
      "14b",
      "14c",

      // Chapter 3 Status checkboxes
      "W8-BENE-4_central_bank",
      "W8-BENE-4_complex_trust",
      "W8-BENE-4_corporation",
      "W8-BENE-4_disregarded_entity",
      "W8-BENE-4_estate",
      "W8-BENE-4_foreign_government_controlled_entity",
      "W8-BENE-4_foreign_government_integral_part",
      "W8-BENE-4_grantor_trust",
      "W8-BENE-4_international_organization",
      "W8-BENE-4_partnership",
      "W8-BENE-4_private_foundation",
      "W8-BENE-4_simple_trust",
      "W8-BENE-4_tax_exempt_organization",

      // Chapter 4 Status checkboxes
      "W8-BENE-5_account_not_financial",
      "W8-BENE-5_active_nffe",
      "W8-BENE-5_certified_limited_life",
      "W8-BENE-5_certified_local_bank",
      "W8-BENE-5_certified_low_value",
      "W8-BENE-5_certified_sponsored",
      "W8-BENE-5_direct_reporting",
      "W8-BENE-5_entity_exempt_owners",
      "W8-BENE-5_excepted_affiliate",
      "W8-BENE-5_excepted_group",
      "W8-BENE-5_excepted_liquidation",
      "W8-BENE-5_excepted_startup",
      "W8-BENE-5_excepted_territory",
      "W8-BENE-5_exempt_retirement",
      "W8-BENE-5_fatca_501c_org_",
      "W8-BENE-5_foreign_government",
      "W8-BENE-5_international_organization",
      "W8-BENE-5_investment_entities",
      "W8-BENE-5_nonparticipating_ffi",
      "W8-BENE-5_nonprofit_org",
      "W8-BENE-5_nonreporting_iga",
      "W8-BENE-5_owner_documented",
      "W8-BENE-5_participating_ffi",
      "W8-BENE-5_passive_nffe",
      "W8-BENE-5_publicly_traded",
      "W8-BENE-5_registered_deemed",
      "W8-BENE-5_reporting_model1",
      "W8-BENE-5_reporting_model2",
      "W8-BENE-5_restricted_distributor",
      "W8-BENE-5_sponsored_direct",
      "W8-BENE-5_sponsored_ffi",
      "W8-BENE-5_territory_financial",

      // Disregarded Entity checkboxes
      "W8-BENE-11_branch_treated_as_nonparticipating_FFI",
      "W8-BENE-11_participating_FFI",
      "W8-BENE-11_reporting_Model1_FFI",
      "W8-BENE-11_reporting_Model2_FFI",
      "W8-BENE-11_us_branch",

      // Treaty Benefits checkboxes
      "W8-BENE-14B_government",
      "W8-BENE-14B_tax_exempt_pension_trust",
      "W8-BENE-14B_other_tax_exempt_organization",
      "W8-BENE-14B_publicly_traded_corporation",
      "W8-BENE-14B_subsidiary_of_publicly_traded",
      "W8-BENE-14B_company_meets_ownership_and_base_erosion_test",
      "W8-BENE-14B_company_meets_derivative",
      "W8-BENE-14B_company_meets_active_trade_or_business",
      "W8-BENE-14B_favorable_discretionary_determination",
      "W8-BENE-14B_no_lob",
      "W8-BENE-14B_other",
      "W8-BENE-14C_claiming_treaty_benefits",
      "W8-BENE-14C_beneficial_owner_derives_item",
      "W8-BENE-14A_beneficial_owner_resident",

      // All other checkbox fields
      "W8-BENE-17_controlled_foreign_corporation",
      "W8-BENE-17_investment_entity",
      "W8-BENE-18_licensed_solely",
      "W8-BENE-19_investing_reinvesting_or_trading",
      "W8-BENE-21_qi_wp_wt",
      "W8-BENE-22_january_17_2013",
      "W8-BENE-23_section_1_1471",
      "W8-BENE-24A_owner_documented_FFI",
      "W8-BENE-24B_FFI_owner_reporting",
      "W8-BENE-24C_auditor_letter",
      "W8-BENE-24D_contingent_beneficiaries",
      "W8-BENE-25A_restricted_distributors",
      "W8-BENE-25B_restricted_distributor_bound_agreement",
      "W8-BENE-25C_restricted_distributor_current_agreement",
      "W8-BENE-26_nonreporting_iga_country",
      "W8-BENE-26_model1_iga",
      "W8-BENE-26_model2_iga",
      "W8-BENE-26_trustee_us",
      "W8-BENE-26_trustee_foreign",

      // Parts XIII-XXVIII checkboxes (sections 27-40)
      "W8-BENE-27_foreign_government_checkbox",
      "W8-BENE-28A_international_org_7701_checkbox",
      "W8-BENE-28B_international_org_intergovernmental",
      "W8-BENE-29A_retirement_plan_treaty",
      "W8-BENE-29B_retirement_plan_organized",
      "W8-BENE-29C_retirement_plan_fewer_50",
      "W8-BENE-29D_retirement_plan_401a",
      "W8-BENE-29E_retirement_plan_earn_income",
      "W8-BENE-29F_retirement_plan_government_sponsored",
      "W8-BENE-30_entity_wholly_owned",
      "W8-BENE-31_territory_financial_institution",
      "W8-BENE-32_excepted_nonfinancial_group",
      "W8-BENE-33_excepted_startup",
      "W8-BENE-34_excepted_liquidation",
      "W8-BENE_35_section_501c",
      "W8-BENE-36_nonprofit_organization",
      "W8-BENE-37A_publicly_traded_nffe",
      "W8-BENE-37B_nffe_affiliate",
      "W8-BENE-38_excepted_territory_nffe",
      "W8-BENE-39_active_nffe",
      "W8-BENE-40A_traded_nffe",
      "W8-BENE-40B_passive_nffe_no_substantial_owners",
      "W8-BENE-40C_passive_nffe_substantial_owners_provided",
      "W8-BENE-41_affiliated_group",
      "W8-BENE-43_nffe",
    ];

    booleanFields.forEach((field) => {
      if (formModel[field] !== undefined) {
        const value = formModel[field];
        const originalValue = value;

        if (typeof value === "string") {
          formModel[field] =
            value.toLowerCase() === "true" ||
            value === "1" ||
            value.toLowerCase() === "yes" ||
            value.toLowerCase() === "selected";
          console.log(
            `🔄 Converted ${field}: "${originalValue}" (string) → ${formModel[field]} (boolean)`
          );
        } else if (typeof value === "number") {
          formModel[field] = value === 1;
          console.log(
            `🔄 Converted ${field}: ${originalValue} (number) → ${formModel[field]} (boolean)`
          );
        } else {
          formModel[field] = !!value;
          if (typeof originalValue !== "boolean") {
            console.log(
              `🔄 Converted ${field}: ${originalValue} (${typeof originalValue}) → ${formModel[field]} (boolean)`
            );
          }
        }
      }
    });
  }

  /**
   * Handle special field mappings and transformations
   */
  private static mapSpecialFields(
    responseModel: W8BENEResponseModel,
    formModel: W8BENEFormModel
  ): void {
    // Check if mapping is already done to prevent special field mapping
    if ((responseModel as any).isMapDone) {
      console.log("W8BEN-E mapping already done, skipping special field mapping...");
      return;
    }

    console.log("🔧 W8BEN-E applying special field mappings for API field name mismatches");

    if ((responseModel as any)["W8-BENE-2_name_of_disregarded_entity"]) {
      (formModel as any)["Name of disregarded entity receiving the payment"] = (
        responseModel as any
      )["W8-BENE-2_name_of_disregarded_entity"];
      console.log(
        "✅ Mapped W8-BENE-2_name_of_disregarded_entity to Name of disregarded entity receiving the payment:",
        (responseModel as any)["W8-BENE-2_name_of_disregarded_entity"]
      );
    }

    if ((responseModel as any)["W8-BENE-3_chapter3_status"]) {
      (formModel as any)["Chapter 3 status"] = (responseModel as any)["W8-BENE-3_chapter3_status"];
      console.log(
        "✅ Mapped W8-BENE-3_chapter3_status to Chapter 3 status:",
        (responseModel as any)["W8-BENE-3_chapter3_status"]
      );
    }

    if ((responseModel as any)["W8-BENE-4_chapter4_status"]) {
      (formModel as any)["Chapter 4 status"] = (responseModel as any)["W8-BENE-4_chapter4_status"];
      console.log(
        "✅ Mapped W8-BENE-4_chapter4_status to Chapter 4 status:",
        (responseModel as any)["W8-BENE-4_chapter4_status"]
      );
    }

    // Permanent address mappings - CRITICAL FIX
    if ((responseModel as any)["Permanent residence address"]) {
      (formModel as any)["Permanent residence address"] = (responseModel as any)[
        "Permanent residence address"
      ];
    }

    // Mailing address mappings - CRITICAL FIX
    if ((responseModel as any)["Mailing address"]) {
      (formModel as any)["Mailing address"] = (responseModel as any)["Mailing address"];
    }

    // Reference number mapping - CRITICAL FIX
    if ((responseModel as any)["W8-BENE-10_reference_number"]) {
      (formModel as any)["Reference number"] = (responseModel as any)[
        "W8-BENE-10_reference_number"
      ];
      console.log(
        "✅ Mapped W8-BENE-10_reference_number to Reference number:",
        (responseModel as any)["W8-BENE-10_reference_number"]
      );
    }

    // Auto-check Foreign TIN checkbox if W8-BENE-Foreign_tax_identifying_number has value
    if (
      formModel["W8-BENE-Foreign_tax_identifying_number"] &&
      formModel["W8-BENE-Foreign_tax_identifying_number"].trim() !== ""
    ) {
      formModel["Foreign TIN"] = true;
    }

    // Auto-check GIIN Applied For checkbox if GIIN has value
    if (formModel["GIIN"] && formModel["GIIN"].trim() !== "") {
      formModel["GIINCheckBox"] = true;
      console.log(
        "✅ Auto-checked GIIN Applied For checkbox because GIIN has value:",
        formModel["GIIN"]
      );
    }

    // Validate TIN and GIIN values and set validation messages - CRITICAL UX FIX
    console.log("🔄 Validating TIN and GIIN values on form load...");

    // Validate U.S. taxpayer identification number (TIN)
    if (
      formModel["U.S. taxpayer identification number"] &&
      formModel["U.S. taxpayer identification number"].trim() !== ""
    ) {
      const tinValue = formModel["U.S. taxpayer identification number"].trim();
      const taxpayerType = formModel["Taxpayer type"] || "";

      // Import validation functions (assuming they're available in this context)
      try {
        const { validateTINFormat } = require("../utils/formUtils");
        const validation = validateTINFormat(tinValue, taxpayerType);

        if (validation.isValid && validation.message) {
          formModel.tinValidationMessage = validation.message;
        } else if (!validation.isValid && validation.message) {
          formModel.tinValidationMessage = validation.message;
        } else {
          formModel.tinValidationMessage = "✓ TIN format appears valid";
        }

        // Auto-select taxpayer type if detected and no type is currently selected
        if (
          validation.isValid &&
          validation.detectedType &&
          (!taxpayerType || taxpayerType === "" || taxpayerType === "---Select---")
        ) {
          let formType = validation.detectedType;
          if (formType === "SSN" || formType === "ITIN") {
            formType = "SSN/ITIN";
          }

          console.log("🔧 Auto-selecting taxpayer type on form load:", formType);
          formModel["Taxpayer type"] = formType;
        }
      } catch (error) {
        console.log("⚠️ Could not validate TIN on load:", error);
        formModel.tinValidationMessage = "✓ TIN value loaded from API";
      }
    }

    // Validate GIIN value
    if (formModel["GIIN"] && formModel["GIIN"].trim() !== "") {
      const giinValue = formModel["GIIN"].trim();

      // Simple GIIN format validation (XXXXXX.XXXXX.XX.XXX)
      const giinPattern = /^[A-Z0-9]{6}\.[A-Z0-9]{5}\.[A-Z]{2}\.[0-9]{3}$/;

      if (giinPattern.test(giinValue)) {
        formModel.giinValidationMessage = "✓ Valid GIIN format";
        console.log("✅ GIIN validation on load - Valid:", giinValue);
      } else {
        formModel.giinValidationMessage =
          "⚠️ Invalid GIIN format. Expected: XXXXXX.XXXXX.XX.XXX (e.g., G018AA.99999.SL.777)";
        console.log("⚠️ GIIN validation on load - Invalid format:", giinValue);
      }
    }

    // Map address fields from API to form (EXISTING LOGIC)
    if (responseModel["Permanent residence address"]) {
      formModel["Permanent residence address"] = responseModel["Permanent residence address"];
    }

    if (responseModel["Permanent city address"]) {
      const addressComponents = parseAddressComponents(responseModel["Permanent city address"]);
      formModel["Permanent address city"] = addressComponents.city;
      const stateFieldType = determineStateFieldType(
        responseModel["Permanent address country"],
        addressComponents.state
      );

      if (stateFieldType === "USCA") {
        formModel["Permanent address state USCA"] = addressComponents.state;
        formModel["Permanent address state NonUS"] = "";
      } else {
        formModel["Permanent address state NonUS"] = addressComponents.state;
        formModel["Permanent address state USCA"] = "";
      }

      formModel["Permanent address zip"] = addressComponents.postalCode;
    }

    if (responseModel["Permanent address country"]) {
      formModel["Permanent address country"] = responseModel["Permanent address country"];
    }
    if (responseModel["W8-BENE-4_hybrid_treaty_claim_yes"]) {
      formModel["W8-BENE-4_hybrid_treaty_claim"] = "yes";
    } else if (responseModel["W8-BENE-4_hybrid_treaty_claim_no"]) {
      formModel["W8-BENE-4_hybrid_treaty_claim"] = "no";
    }

    if (responseModel["Mailing address"]) {
      formModel["Mailing address"] = responseModel["Mailing address"];
    }

    if (responseModel["Mailing address city"]) {
      const addressComponents = parseAddressComponents(responseModel["Mailing address city"]);
      formModel["Mailing city address"] = addressComponents.city;
      const stateFieldType = determineStateFieldType(
        responseModel["Mailing address country"],
        addressComponents.state
      );

      if (stateFieldType === "USCA") {
        formModel["Mailing address state USCA"] = addressComponents.state;
        formModel["Mailing address state NonUS"] = "";
      } else {
        formModel["Mailing address state NonUS"] = addressComponents.state;
        formModel["Mailing address state USCA"] = "";
      }

      formModel["Mailing address zip"] = addressComponents.postalCode;
    }

    if (responseModel["Mailing address country"]) {
      formModel["Mailing address country"] = responseModel["Mailing address country"];
    }

    // Map signature fields
    if (responseModel["Signature"]) {
      formModel["Signature"] = responseModel["Signature"];
    }

    if (responseModel["Signature_date"]) {
      formModel["Signature_date"] = responseModel["Signature_date"];
    }

    // Map treaty benefit fields from API to indexed form fields (for treaty claims)
    if (responseModel["W8-BENE-15_treaty_provision_and_paragraph"]) {
      formModel["BENE-15-Treaty_article_0"] =
        responseModel["W8-BENE-15_treaty_provision_and_paragraph"];
    }

    if (responseModel["W8-BENE-15_withholding_rate_percentage"]) {
      formModel["BENE-15-Treaty_percentage_0"] =
        responseModel["W8-BENE-15_withholding_rate_percentage"];
    }

    if (responseModel["W8-BENE-15_income_type"]) {
      formModel["BENE-15-Treaty_typeOfIncome_0"] = responseModel["W8-BENE-15_income_type"];
    }

    // Handle API fields with underscores/dashes - map to form fields with spaces
    Object.keys(responseModel).forEach((responseField) => {
      const value = responseModel[responseField];
      if (value !== undefined) {
        const formFieldName = responseField.replace(/_/g, " ").replace(/-/g, " ");
        if (formFieldName !== responseField && (formModel as any)[formFieldName] !== undefined) {
          console.log(
            `W8BEN-E mapping API field "${responseField}" to form field "${formFieldName}"`
          );
          (formModel as any)[formFieldName] = value;
        }
      }
    });

    // Map substantial owners table data - CRITICAL FIX
    console.log("🔍 Checking for substantial owners table data...");
    if (responseModel.tables && responseModel.tables.substantial_us_owners) {
      console.log(
        "✅ Found substantial_us_owners table:",
        responseModel.tables.substantial_us_owners
      );
      const substantialOwners = responseModel.tables.substantial_us_owners;

      // Map each substantial owner to individual form fields
      for (let i = 0; i < substantialOwners.length && i < 10; i++) {
        // Limit to 10 owners max
        const owner = substantialOwners[i];
        const ownerNum = i + 1;

        if (owner.name) {
          (formModel as any)[`W8-BENE-substantial_owner_${ownerNum}_name`] = owner.name;
          console.log(`✅ Mapped substantial owner ${ownerNum} name:`, owner.name);
        }

        if (owner.address) {
          (formModel as any)[`W8-BENE-substantial_owner_${ownerNum}_address`] = owner.address;
          console.log(`✅ Mapped substantial owner ${ownerNum} address:`, owner.address);
        }

        if (owner.tin) {
          (formModel as any)[`W8-BENE-substantial_owner_${ownerNum}_tin`] = owner.tin;
          console.log(`✅ Mapped substantial owner ${ownerNum} TIN:`, owner.tin);
        }
      }
    } else {
      console.log("❌ No substantial_us_owners table found in API response");
      console.log(
        "Available tables:",
        responseModel.tables ? Object.keys(responseModel.tables) : "No tables object"
      );
    }
  }
}
